import React, {useState} from 'react';
import { Navbar, Button, NavDropdown, Form, FormControl, Nav } from 'react-bootstrap';
import { auth } from '../firebase'
import Logo from '../images/logo.png'

const Navigation = (props) => {
    const onLogOut = () =>{
        auth.signOut().then(function() {
            // Sign-out successful.
            props.user=false
          }).catch(function(error) {
            // An error happened.
          });
    }



    return(
        <div className="app_navigation_bar">
            <Navbar bg="dark" variant="dark" expand="lg" fixed="top">
                <Navbar.Brand href="/Home" style={{marginLeft:"2rem",marginRight:"6rem"}}>Admissions</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">

                    <Nav className="mr-auto" >
                        <Nav.Link href="/Home">Home</Nav.Link>
                        {
                            props.user?                            
                              <Nav.Link href="/AllOrders">All Students (Admin) </Nav.Link>
                            :
                            <Nav>           
                                <Nav.Link href="/ArtsForm">Apply (Arts)</Nav.Link>
                                <Nav.Link href="/CommerceForm">Apply (Commerce)</Nav.Link>    
                                <Nav.Link href="/ArtsStatus/appverification">My Application Status (Arts)</Nav.Link>     
                                <Nav.Link href="/CommerceStatus/appverification">My Application Status (Commerce)</Nav.Link>                        
                            </Nav>    
                        }                                   
                    </Nav>                    
                    {
                        !props.user
                        ?   
                            <Nav style={{float: "right"}}>
                                <Nav.Link href="/SignIn" style={{marginRight:"1rem"}} >College Log In</Nav.Link>
                            </Nav>
                        :
                            <Nav style={{float: "right"}}>
                                <Nav.Link onClick={onLogOut} style={{marginRight:"1rem"}} >Log Out</Nav.Link>
                            </Nav>
                    }     
                </Navbar.Collapse>
            </Navbar>            
        </div>
    )
}

export default Navigation;